import { useState } from 'react';
import { Toast } from '@base-ui/react/toast';
import Dialog from '../../../../components/patterns/Dialog.jsx';
import Tooltip from '../../../../components/patterns/Tooltip.jsx';
import Button from '../../../../components/primitives/Button.jsx';
import Input from '../../../../components/primitives/Input.jsx';
import GalleryExample from './GalleryExample.jsx';
import GallerySection from './GallerySection.jsx';

const OverlaysSection = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const toastManager = Toast.useToastManager();

  const handleOpenDialog = () => setDialogOpen(true);
  const handleCloseDialog = () => setDialogOpen(false);
  const handleSaved = () => {
    setDialogOpen(false);
    toastManager.add({ title: 'Schedule saved', description: 'Next run Monday at 9:00.', type: 'success' });
  };
  const handleShowError = () => {
    toastManager.add({ title: 'Gmail is disconnected', description: 'Reconnect Gmail to keep sending reminders.', type: 'error' });
  };
  const handleShowInfo = () => {
    toastManager.add({ title: 'Run started', description: 'You can leave this page; Pieve keeps working.', type: 'info' });
  };

  return (
    <GallerySection id="overlays" title="Dialogs, tooltips and toasts" description="Dialogs hold one focused task. Toasts confirm what just happened, in the same words as the action.">
      <GalleryExample label="Open one">
        <Button variant="secondary" onClick={handleOpenDialog}>
          Edit schedule
        </Button>
        <Tooltip content="Runs every Monday at 9:00">
          <Button variant="ghost">Hover or focus me</Button>
        </Tooltip>
        <Button variant="secondary" onClick={handleShowInfo}>
          Show info toast
        </Button>
        <Button variant="secondary" onClick={handleShowError}>
          Show error toast
        </Button>
      </GalleryExample>
      <Dialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        title="Edit schedule"
        description="Pieve runs this automation on its own at the time you set."
        footer={
          <>
            <Button variant="ghost" onClick={handleCloseDialog}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSaved}>
              Save schedule
            </Button>
          </>
        }>
        <Input label="Time" defaultValue="Monday, 9:00" />
      </Dialog>
    </GallerySection>
  );
};

export default OverlaysSection;
